import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

const countries = {
    'en-GB': 'UK',
    'en-US': 'US',
    'en-CA': 'Canada',
    'da-DK': 'Denmark',
    'es-ES': 'Spain',
    'fi-FI': 'Finland',
    'de-DE': 'Germany',
    'el-GR': 'Greece',
    'hr-HR': 'Croatia',
    'it-IT': 'Italy',
    'nb-NO': 'Norway',
    'nl-NL': 'Netherlands',
    'sv-SE_e': 'Sweden - East Coast',
    'sv-SE_w': 'Sweden - West Coast',
    'sv-SE_l': 'Sweden - Lakes',
    'fr-FR': 'France'
}

export default {
    data() {
        return {
            fetchedProduct: null
        }
    },
    computed: {
        getProducts() {
            const lang = this.$route.query.paintLocation
            if (!lang) {
                return []
            }
            return this.getProductsData(lang)
                .map(item => {
                    let local =
                        this.getProductsData('local')
                            .filter(
                                localItem =>
                                    `${item.id}`.toLowerCase() ===
                                        `${localItem.id}`.toLowerCase() &&
                                    localItem.countryAllowed.includes(countries[lang])
                            )
                            .pop() || {}
                    if (item.productId === '71150' && lang === 'fi-FI') {
                        local =
                            this.getProductsData('local')
                                .filter(localItem => localItem.productId === '71150X')
                                .pop() || {}
                    }
                    if (
                        !local ||
                        (local.countryAllowed &&
                            local.countryAllowed.length &&
                            !local.countryAllowed.filter(
                                country => country.indexOf(countries[lang]) >= 0
                            ).length)
                    ) {
                        return null
                    }
                    return Object.assign(
                        {
                            // label: item.productName,
                            label: local.name || item.productName,
                            value: item.productId,
                            img: item.productPicture,
                            sublabel: local.position,
                            features: local.keyFeatures
                        },
                        item,
                        local
                    )
                })
                .filter(item => !!item)
        },
        // almost duplicated from getProducts, must make it better!
        getProductsForVolume() {
            const lang = this.$route.query.paintLocation
            if (!lang) {
                return []
            }
            return this.getProductsData(lang)
                .map(item => {
                    let local =
                        this.getProductsData('local')
                            .filter(
                                localItem =>
                                    `${item.id}`.toLowerCase() === `${localItem.id}`.toLowerCase()
                            )
                            .pop() || {}
                    if (item.productId === '71150' && lang === 'fi-FI') {
                        local =
                            this.getProductsData('local')
                                .filter(localItem => localItem.productId === '71150X')
                                .pop() || {}
                    }
                    if (
                        !local ||
                        (local.countryAllowed &&
                            local.countryAllowed.length &&
                            !local.countryAllowed.filter(
                                country => country.indexOf(countries[lang]) >= 0
                            ).length)
                    ) {
                        return null
                    }
                    return Object.assign(
                        {
                            // label: item.productName,
                            label: local.name || item.productName,
                            value: item.productId,
                            img: item.productPicture,
                            sublabel: local.position,
                            features: local.keyFeatures
                        },
                        item,
                        local
                    )
                })
                .filter(item => !!item)
        },
        getProduct() {
            return this.getSelectedProduct
        },
        productFromAPI() {
            return this.fetchedProduct
        },
        getProductsToCalculate() {
            // return this.getProductsData('local')
            return this.getProducts.filter(item => item.position)
        },

        /* eslint no-return-assign: "off" */
        getSelectedProduct() {
            return (
                this.getProducts
                    .filter(
                        item =>
                            `${item.productId}`.toLowerCase() ===
                            `${this.$route.query.antifouling}`.toLowerCase()
                    )
                    .pop() || {}
            )
        },
        getProductsData() {
            return key => {
                this.getLocalProducts(key)
                return this.localProducts(key)
            }
        },
        ...mapGetters('questions', [
            'boatType',
            'boatMaterial',
            'sailFrequency',
            'country',
            'localProducts'
        ])
    },

    methods: {
        ...mapActions('questions', [
            'setBoatType',
            'setBoatMaterial',
            'setSailFrequency',
            'setCountry',
            'getLocalProducts'
        ])
        // getProductFromAPI() {
        //     this.fetchedProduct =
        //     axios
        //         .get(
        //             `//hempelproductapi.azurewebsites.net/api/v1/products/${
        //                 this.$route.query.antifouling
        //             }`,
        //             {
        //                 headers: {
        //                     'Accept-Language': this.$route.query.paintLocation.split('_')[0]
        //                 }
        //             }
        //         )
        //         .then(response => {
        //             this.fetchedProduct = response.data
        //         })
        //         .catch(() => {})
        // }
    }
}
